import { render, staticRenderFns } from "./downloaded.vue?vue&type=template&id=3bc70371"
import script from "./downloaded.vue?vue&type=script&lang=js"
export * from "./downloaded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports